import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { OrderFlowControllerPage } from './order-flow-controller.page';

const routes: Routes = [
  {
    path: '',
    component: OrderFlowControllerPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrderFlowControllerPageRoutingModule {}
